import {useOrganShareFilterValues} from "./hooks/useOrganShareFilterValues";
import {ListFilterValuesContext} from "../../../hooks/list/ListFilterValuesContext";
import {OrganShareList} from "./OrganShareList";

export function OrganShareListWrapper() {
    const {pageInfoOnFilter, filterValues, searchList, listQueryType} = useOrganShareFilterValues();

    return (
        <ListFilterValuesContext.Provider
            value={{
                filterValues,
                pageInfoOnFilter,
                searchList,
                listQueryType,
            }}
        >
            <OrganShareList />
        </ListFilterValuesContext.Provider>
    );
}